import React from 'react';
import SpeedIcon from '@mui/icons-material/Speed';
import SensorIcon from '@mui/icons-material/SensorsRounded';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoardOutlined';
import Device from '../deviceList/Device';
import { useDevicesStore } from '../stores';

const CategoryIcons = {
  counter: { name: 'Счетчики', icon: SpeedIcon },
  sensor: { name: 'Сенсоры', icon: SensorIcon },
  controller: { name: 'Контроллеры', icon: DeveloperBoardIcon },
};

const groupByType = (objectDevices) => {
  return objectDevices.reduce((acc, dev) => {
    const key = dev.type?.key;
    if (!acc[key]) acc[key] = [];
    acc[key].push(dev);
    return acc;
  }, {});
};

const DevicesList = ({ user }) => {
  const { groupDevices } = useDevicesStore();

  return (
    <>
      {groupDevices.length !== 0 &&
        groupDevices.map((object) => {
          const objectDevices = object.devices || [];
          const groupedDevices = groupByType(objectDevices);

          return (
            <div key={object?.object_id}>
              <h2 className="text-xl sm:text-2xl font-medium mb-4">{object?.object_address}</h2>

              {Object.entries(groupedDevices).map(([typeKey, groupDevices]) => {
                const Category = CategoryIcons[typeKey];
                const Icon = Category ? Category.icon : null;
                const typeName = Category ? Category.name : typeKey;

                return (
                  <div key={typeKey}>
                    <div className="flex items-center gap-2 mb-3">
                      {Icon && <Icon className="text-gray-600" />}
                      <h3 className="text-2xl">{typeName}</h3>
                    </div>

                    <div className="bg-white shadow-3xl mb-4 rounded-3xl p-4">
                      <div className="flex flex-col gap-4 min-w-full">
                        {groupDevices.map((device, index) => {
                          return React.createElement(Device, {
                            key: index,
                            device: device,
                            user: user,
                            timeZone: object?.object_time_zone,
                          });
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
    </>
  );
};
export default DevicesList;
